import React, { useEffect, useState } from 'react';
import { useTranslations } from '../../localization/useTranslations';

const AccountBar = () => {
  const [userData, setUserData] = useState({
    name: '',
    email: '',
    avatarUrl: '',
  });
  const [isLoading, setIsLoading] = useState(true);
  const translations = useTranslations();
  const { route } = translations;
  const myAccountSlug = window.myAccountPageSlug || 'my-account';

  useEffect(() => {
    const user = window.crm_user;

    if (!user) return;

    const avatarUrl = window.crm_user?.user_meta?.avatar_url || window.defaultUserAvatar;
    const userFirstName = window?.crm_user?.user?.first_name || '';
    const userLastName = window?.crm_user?.user?.last_name || '';
    const userEmail = window?.crm_user?.user?.email || '';

    setUserData({
      name: `${userFirstName} ${userLastName}`,
      email: userEmail,
      avatarUrl: avatarUrl,
    });

    setIsLoading(false);
  }, [translations?.snackBarMessages?.somethingWentWrong]);

  if (isLoading) {
    return <div className="user-card" style={{ height: '64px' }} />;
  }

  return (
    <div className="user-card" id="user-card">
      <div className="user-card__wrapper">
        <div className="user-card__content-wrapper">
          <div className="user-card__avatar-wrapper">
            <img src={userData.avatarUrl} alt="User Avatar" />
          </div>
          <div className="user-card__user-info">
            <p className="user-card__label basic-16">{translations?.newsletter?.userCardLabel || 'My Newsletters'}</p>
            <h5 className="user-card__user-name">{userData.name.trim().length > 0 ? userData.name : userData.email}</h5>
            {userData.name.trim().length > 0 && <span className="user-card__email">{userData.email}</span>}
          </div>
        </div>
        <div className="user-card__link-wrapper">
          <a href={`/${myAccountSlug}/#/${route?.myNewsletters}/`} className="user-card__mfa-link link link-14">
            <span className="link__text">{translations?.accountNavigation?.myNewsletters || 'My Newsletters'}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default AccountBar;
